import React from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { object, string } from "prop-types";
import { Headline } from "@quintype/arrow";

import HeroImage from "../../../atoms/hero-image";

import "./also-read.m.css";
import { getLinkedStory } from "../../../../../api/utils";
import CardImage from "../../../atoms/cardimage";

const AlsoReadCard = ({ story, element, index, elementsLength }) => {
  const { linkedStory, linkedStorySlug } = getLinkedStory(element, story);
  const idx = index + 1;
  return (
    <div styleName="main-content">
      <div styleName={`also-read ${idx % 2 == 0 ? "also-read-padding-left" : "also-read-padding-right"}`}>
        <div styleName="title">ಇದನ್ನೂ ಓದಿ:</div>
        <Link styleName="content" href={linkedStorySlug}>
          <Headline story={linkedStory} headerLevel="4" />

          <CardImage
            story={linkedStory}
            aspectRatio={[16, 9]}
            imageType="image16x9"
            renderedWidth={720}
            widths={[700]}
            showVideoIcon={true}
          />
        </Link>
      </div>
      {idx % 2 !== 0 && idx !== elementsLength && <div styleName="v-line" className="hide-mobile"></div>}
      {idx !== elementsLength && <div styleName="v-line" className="hide-desktop"></div>}
    </div>
  );
};

const AlsoRead = ({ story, elements }) => {
  if (elements?.length === 1) {
    const { linkedStory, linkedStorySlug } = getLinkedStory(elements[0], story);

    return (
      <div styleName="also-read">
        <div styleName="title">ಇದನ್ನೂ ಓದಿ:</div>
        <Link styleName="single-content" href={linkedStorySlug}>
          <Headline story={linkedStory} headerLevel="4" />
        </Link>
      </div>
    );
  }

  return (
    <div styleName="also-read-wrapper">
      {elements.map((item, idx) => {
        return <AlsoReadCard story={story} element={item} index={idx} elementsLength={elements.length} />;
      })}
    </div>
  );
};

export default AlsoRead;
